var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0102 2.5C55.0102 3.16304 54.7468 3.79893 54.278 4.26777C53.8092 4.73661 53.1733 5 52.5102 5C43.2276 5 34.3253 8.68749 27.7615 15.2513C21.1977 21.815 17.5102 30.7174 17.5102 40V46.475L25.7352 38.225C25.9683 37.9919 26.245 37.807 26.5496 37.6809C26.8542 37.5547 27.1806 37.4898 27.5102 37.4898C27.8399 37.4898 28.1663 37.5547 28.4709 37.6809C28.7754 37.807 29.0521 37.9919 29.2852 38.225C29.5183 38.4581 29.7032 38.7348 29.8294 39.0394C29.9555 39.3439 30.0205 39.6704 30.0205 40C30.0205 40.3296 29.9555 40.6561 29.8294 40.9606C29.7032 41.2652 29.5183 41.5419 29.2852 41.775L16.7852 54.275C16.5475 54.5026 16.2671 54.681 15.9602 54.8C15.661 54.9323 15.3374 55.0006 15.0102 55.0006C14.6831 55.0006 14.3595 54.9323 14.0602 54.8C13.7534 54.681 13.473 54.5026 13.2352 54.275L0.735229 41.775C0.26447 41.3042 0 40.6658 0 40C0 39.3342 0.26447 38.6958 0.735229 38.225C1.20599 37.7542 1.84447 37.4898 2.51023 37.4898C3.17598 37.4898 3.81447 37.7542 4.28523 38.225L12.5102 46.475V40C12.5102 29.3913 16.7245 19.2172 24.226 11.7157C31.7274 4.21427 41.9016 0 52.5102 0C53.1733 0 53.8092 0.263392 54.278 0.732233C54.7468 1.20107 55.0102 1.83696 55.0102 2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrow);
export default __webpack_public_path__ + "static/media/white-arrow.2b2cde32d47a335cc87b573b153b1ac7.svg";
export { ForwardRef as ReactComponent };